import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { SpotifyFeature } from "@/components/site/SpotifyFeature";
import { Labels } from "@/components/site/Labels";
import { Stats } from "@/components/site/Stats";
import { RadioSupport } from "@/components/site/RadioSupport";
import { DJMixes } from "@/components/site/DJMixes";
import { LiveUniverse } from "@/components/site/LiveUniverse";
import { PressMedia } from "@/components/site/PressMedia";
import { Releases } from "@/components/site/Releases";
import { ComingSoon } from "@/components/site/ComingSoon";
import { TrustedBy } from "@/components/site/TrustedBy";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Toaster } from "@/components/ui/sonner";

export default function HomePage() {
  return (
    <SmoothScroll>
      <div
        data-testid="homepage-root"
        className="relative min-h-screen w-full bg-bg text-ink antialiased"
      >
        <Navbar />
        <main>
          <Hero />
          <SpotifyFeature />
          <Labels />
          <Stats />
          <RadioSupport />
          <DJMixes />
          <LiveUniverse />
          <PressMedia />
          <Releases />
          <ComingSoon />
          <TrustedBy />
          <About />
          <Contact />
        </main>
        <Footer />
        <Toaster theme="dark" richColors position="bottom-right" />
      </div>
    </SmoothScroll>
  );
}
